// extracted by mini-css-extract-plugin
export default {"content":"PLo5Z","day":"Rvzm2","past":"Rg7ag","dayText":"dT44x","today":"_25Sya","events":"qDdVx","event":"_9nR5N"};